<template>
  <div class="home-page">
    <site-header />
    <div class="home">
      <!-- Banner -->
      <section class="banner-new">
        <swiper :options="swiperOptions" class="my-swiper">
          <!-- 第一张：企业用工风险解决专家 -->
          <!-- <swiper-slide v-if="false">
            <div class="contant-swiper2 flex-center">
              <div class="left2">
                <p class="swiper-title1">企业用工风险解决专家</p>
                <p class="swiper-title2">行业领先 | 精准赋能 | 持续陪伴式服务</p>
                <button type="button" class="btn-zxzx" @click="handleConsult">咨询了解</button>
              </div>
              <div class="right-box">
                <div class="right">
                  <div class="swiper-card-item dw1">
                    <p>工商注册信息核查</p>
                    <span>核验企业/个体工商户注册信息及经营状态</span>
                  </div>
                  <div class="swiper-card-item dw2">
                    <p>运营商信息</p>
                    <span>核查手机号状态、入网时长、通话及活跃情况</span>
                  </div>
                  <div class="swiper-card-item dw3">
                    <p>身份信息核实</p>
                    <span>核验姓名、身份证号等身份信息真实性</span>
                  </div>
                  <div class="swiper-card-item dw4">
                    <p>金融信贷风险核查</p>
                    <span>评估信贷逾期记录、负债及还款风险</span>
                  </div>
                  <div class="swiper-card-item dw5">
                    <p>黑名单(非银行机构)</p>
                    <span>核查是否存在于非银行机构黑名单中</span>
                  </div>
                  <div class="swiper-card-item dw6">
                    <p>高风险核查</p>
                    <span>核查执行公告、曝光台、失信、判决文书、开庭公告、法院公告等风险信息</span>
                  </div>
                  <img src="@/assets/images/img1.png" alt="" class="image" />
                </div>
              </div>
            </div>
          </swiper-slide> -->

          <swiper-slide>
            <div class="banner-bg banner-bg-1">
              <div class="left banner-left">
                <p class="swiper-title1">企业用工风险解决专家</p>
                <p class="swiper-title2">行业领先 | 精准赋能 | 持续陪伴式服务</p>
                <button type="button" class="btn-zxzx" @click="handleConsult">咨询了解</button>
              </div>
              <img src="@/assets/images/b1.png">
            </div>
          </swiper-slide>

          <!-- 第二张：稳定且强大的服务系统 -->
          <!-- <swiper-slide>
            <div class="banner-bg banner-bg-2">
              <div class="left banner-left">
                <p class="swiper-title1">稳定且强大的服务系统</p>
                <p class="swiper-title2">自有技术团队，系统稳定，可随时优化调整</p>
                <button type="button" class="btn-zxzx" @click="handleConsult">咨询了解</button>
              </div>
              <img src="@/assets/images/b2.png">
            </div>
          </swiper-slide> -->

          <!-- 第三张：稳定且强大的服务系统 -->
          <!-- <swiper-slide>
            <div class="banner-bg banner-bg-2">
              <div class="left banner-left">
                <p class="swiper-title1">稳定且强大的服务系统</p>
                <p class="swiper-title2">自有技术团队，系统稳定，可随时优化调整</p>
                <button type="button" class="btn-zxzx" @click="handleConsult">咨询了解</button>
              </div>
              <img src="@/assets/images/banner2_new2.png">
            </div>
          </swiper-slide> -->

          <swiper-slide>
            <div class="banner-bg banner-bg-2">
              <div class="left banner-left">
                <p class="swiper-title1">稳定且强大的服务系统</p>
                <p class="swiper-title2">自有技术团队，系统稳定，可随时优化调整</p>
                <button type="button" class="btn-zxzx" @click="handleConsult">咨询了解</button>
              </div>
              <img src="@/assets/images/b3.png">
            </div>
          </swiper-slide>

           <swiper-slide>
            <div class="banner-bg banner-bg-2">
              <div class="left banner-left">
                <p class="swiper-title1">智能化员工背景调查服务提供商</p>
                <p class="swiper-title2">快速有效防范招聘风险，让职业信用环境更美好</p>
                <button type="button" class="btn-zxzx" @click="handleConsult">咨询了解</button>
              </div>
              <img src="@/assets/images/b4.png">
            </div>
          </swiper-slide>
        </swiper>
      </section>

      <!-- 构建人力资源安全体系 -->
      <section class="back-tone mod t-l">
        <div class="mod-title">
          <div class="title">构建人力资源安全体系</div>
          <div class="sed-title">武汉云查信息技术有限公司专注产品体系研究，覆盖全场景的雇佣安全管理</div>
        </div>
        <div class="content container">
          <div class="cards-row">
            <div v-for="(product, index) in products" :key="product.name" class="card-col">
              <div class="card-title pointer" :class="{ active: activeProduct === index }"
                @click="activeProduct = index">
                {{ product.name }}
              </div>
              <div class="card">
                <div class="up">
                  <div class="title">{{ product.version }}</div>
                  <div class="sub-title">{{ product.position }}</div>
                </div>
                <div class="down">
                  <ul class="clear">
                    <li v-for="item in product.items" :key="item">{{ item }}</li>
                  </ul>
                </div>
              </div>
              <!-- <div v-else class="card custom">
                <div class="title">{{ product.version }}</div>
                <div class="detail">{{ product.desc }}</div>
                <img :src="backToneCard" alt="" />
                <button type="button" class="btn" @click="handleConsult">联系我们</button>
              </div> -->
            </div>
          </div>
        </div>
      </section>

      <!-- 全流程在线化操作 -->
      <section class="plant-wide mod t-c">
        <div class="mod-title">
          <div class="title">全流程在线化操作</div>
          <div class="sed-title">安全合规的流程，快速交付每一份严谨客观的背调报告</div>
        </div>
        <div class="step-box">
          <img src="@/assets/images/step_new_1.png" alt="" class="step-image" />
        </div>
      </section>

      <!-- 我们的背调优势 -->
      <section class="back-advantage mod t-c">
        <div class="mod-title">
          <div class="title">我们的背调优势</div>
          <div class="sed-title">致力于成为中国领先的智能化背景调查提供商</div>
        </div>
        <div class="content container flex-center advantages-box">
          <div v-for="item in advantages" :key="item.title" class="item">
            <div class="icon">
              <img :src="item.icon" alt="" />
            </div>
            <div class="title">{{ item.title }}</div>
            <div class="detail">{{ item.detail }}</div>
          </div>
        </div>
      </section>
    </div>
    <site-footer />
    <site-aside />
  </div>
</template>

<script>
import SiteHeader from '@/components/layout/SiteHeader.vue'
import SiteFooter from '@/components/layout/SiteFooter.vue'
import SiteAside from '@/components/layout/SiteAside.vue'

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'HomeView',
  components: {
    SiteHeader,
    SiteFooter,
    SiteAside,
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true
        }
      },
      typedText: '',
      typedWords: ['背调', '背景调查', '雇佣安全', '人才审计'],
      wordIndex: 0,
      charIndex: 0,
      isDeleting: false,
      typingTimer: null,
      activeProduct: 1,
      activeStep: 0,
      activeTab: 0,
      bannerBank: require('@/assets/images/banner-bank.png'),
      bannerPic: require('@/assets/images/banner-pic.png'),
      backToneCard: require('@/assets/images/back-tone-card.png'),
      backWideBg: require('@/assets/images/back-wide-bg.png'),
      certImages: [
        require('@/assets/images/02.png'),
        require('@/assets/images/03.png'),
        require('@/assets/images/04.png'),
        require('@/assets/images/05.png')
      ],
      products: [
        {
          name: '面试预检',
          version: '迅捷版',
          deliveryTime: '10秒',
          position: '适用岗位：基层 / 蓝领',
          items: ['身份信息核实', '运营商三维验证', '工商注册信息核查', '金融信贷风险核查', '黑名单(非银行机构)', '教育经历验证','民事诉讼核查']
        },
        {
          name: '入职前背调',
          version: '标准版',
          deliveryTime: '2个工作日',
          position: '适用岗位：普通白领',
          items: [
            '身份信息核实', '负面社会安全', '个人涉诉记录', '失信被执行人',
            '信贷风险记录', '教育经历验证', '工作履历核实 (一段)', '工作表现鉴定 (一段)'
          ]
        }
      ],
      processSteps: [
        {
          icon: require('@/assets/images/plant-wide01.png'),
          title: '企业发起背调',
          detail: '可通过武汉云查信息技术有限公司平台或<br>第三方招聘系统发起'
        },
        {
          icon: require('@/assets/images/plant-wide02.png'),
          title: '候选人在线授权',
          detail: '武汉云查信息技术有限公司自动发送短信<br>候选人电子签授权'
        },
        {
          icon: require('@/assets/images/plant-wide03.png'),
          title: '基础客观项验证',
          detail: '对接全数据源<br>秒级查询'
        },
        {
          icon: require('@/assets/images/plant-wide04.png'),
          title: '工作履历调查',
          detail: '优先自主寻访HR<br>对证明人进行验证'
        },
        {
          icon: require('@/assets/images/plant-wide05.png'),
          title: '背调报告质检',
          detail: '对背调过程与报告质量<br>进行质检'
        },
        {
          icon: require('@/assets/images/plant-wide05.png'),
          title: '交付背调报告',
          detail: '企业收到查验PDF报告<br>顾问对报告解读'
        }
      ],
      serviceTabs: [
        {
          label: '推荐常用产品',
          items: [
            { title: '身份信息验证', detail: '身份证持有者的姓名、号码与官方数据信息进行比对' },
            { title: '刑事诉讼记录', detail: '通过法院公示及官方渠道查验是否存在刑事类诉讼记录' },
            { title: '民事诉讼记录', detail: '个人存在民事诉讼类记录，包含劳动争议类诉讼' },
            { title: '商业利益冲突', detail: '查询名下工商注册信息，有效防范潜在的商业利益冲突风险' },
            { title: '教育经历验证', detail: '核实学历、学位的真实性，包含国内、海外的教育经历' },
            { title: '工作履历核实', detail: '通过对候选人前雇主HR部门访谈，核实候选人的离职时间、职位名称、薪资待遇、主管姓名、主管职位、离职原因、有无违纪违规、竞业限制、劳动纠纷。' },
            { title: '工作表现鉴定', detail: '通过对候选人前雇主的上级/同事，访谈候选人的工作表现及工作能力。' }
          ]
        },
        {
          label: '基础客观项查询',
          items: [
            { title: '身份信息验证', detail: '身份证持有者的姓名、号码与官方数据信息进行比对' },
            { title: '刑事诉讼记录', detail: '通过法院公示及官方渠道查验是否存在刑事类诉讼记录' },
            { title: '民事诉讼记录', detail: '个人存在民事诉讼类记录，包含劳动争议类诉讼' },
            { title: '商业利益冲突', detail: '查询名下工商注册信息，有效防范潜在的商业利益冲突风险' },
            { title: '教育经历验证', detail: '核实学历、学位的真实性，包含国内、海外的教育经历' }
          ]
        },
        {
          label: '履历项调查',
          items: [
            { title: '工作履历核实', detail: '通过对候选人前雇主HR部门访谈，核实候选人的离职时间、职位名称、薪资待遇、主管姓名、主管职位、离职原因、有无违纪违规、竞业限制、劳动纠纷。' },
            { title: '工作表现鉴定', detail: '通过对候选人前雇主的上级/同事，访谈候选人的工作表现及工作能力。' }
          ]
        }
      ],
      advantages: [
        {
          icon: require('@/assets/images/ys1.png'),
          title: '高效交付深度的履历调查',
          detail: '依托庞大的自有HR证明人资源以及证明人验证系统，针对履历的调查我们优先自主寻访HR，大幅提升履历真实度还原。'
        },
        {
          icon: require('@/assets/images/ys2.png'),
          title: '优质合规的数据资源',
          detail: '获得众多合规数据源授权查询，包括司法体系、征信持证机构、教育系统等。通过API对接实时查询，进一步保障数据精准度。'
        },
        {
          icon: require('@/assets/images/ys3.png'),
          title: '丰富的平台对接经验',
          detail: '依据合作平台特点，背调服务可在平台的集成场景，与合作平台一起为客户建立更全面的人力资源服务。'
        },
        {
          icon: require('@/assets/images/ys4.png'),
          title: '专业的背调顾问团队',
          detail: '武汉云查信息技术有限公司拥有专业的背调顾问团队，具备丰富的行业经验和专业知识，为客户提供个性化的咨询和解决方案。'
        },
        {
          icon: require('@/assets/images/ys5.png'),
          title: '严格的隐私保护措施',
          detail: '武汉云查信息技术有限公司严格遵守相关法律法规，采取多种技术手段和管理措施，确保客户数据的安全和隐私。'
        },
        {
          icon: require('@/assets/images/ys6.png'),
          title: '持续的技术创新',
          detail: '武汉云查信息技术有限公司不断进行技术创新，优化背调流程和工具，提高效率和准确性，为客户提供更优质的服务。'
        }
      ]
    }
  },
  computed: {
    currentServiceItems() {
      return this.serviceTabs[this.activeTab].items
    }
  },
  mounted() {
    this.startTyping()
  },
  beforeDestroy() {
    clearTimeout(this.typingTimer)
  },
  methods: {
    handleConsult() {
      window.open('tel:400-9669-857')
    },
    startTyping() {
      const tick = () => {
        const currentWord = this.typedWords[this.wordIndex]
        if (!this.isDeleting) {
          this.typedText = currentWord.substring(0, this.charIndex + 1)
          this.charIndex++
          if (this.charIndex === currentWord.length) {
            this.isDeleting = true
            this.typingTimer = setTimeout(tick, 2000)
            return
          }
        } else {
          this.typedText = currentWord.substring(0, this.charIndex - 1)
          this.charIndex--
          if (this.charIndex === 0) {
            this.isDeleting = false
            this.wordIndex = (this.wordIndex + 1) % this.typedWords.length
          }
        }
        this.typingTimer = setTimeout(tick, this.isDeleting ? 80 : 150)
      }
      tick()
    }
  }
}
</script>

<style lang="scss" scoped>
// ===== 全局重置 =====
* {
  box-sizing: border-box;
}

.home-page {
  min-height: 100vh;
  overflow-x: hidden;
}

.home {
  padding-top: 72px;
  overflow-x: hidden;

  @media (max-width: 768px) {
    padding-top: 56px;
  }
}

.container {
  width: 100%;
  margin: 0 auto;
  padding: 50px 200px;
}

// ===== 工具类 =====
.flex-center {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.bold {
  font-weight: 600;
}

.pointer {
  cursor: pointer;
}

.clear::after {
  content: '.';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

// ===== Swiper =====
.my-swiper {
  width: 100%;
  height: 598px;
  overflow: visible !important;

  @media (max-width: 992px) {
    height: auto;
    min-height: 500px;
  }

  @media (max-width: 768px) {
    min-height: 400px;
  }
}

.swiper-slide {
  display: flex;
  align-items: center;
  justify-content: center;
}

// ===== Banner 通用样式 =====
.banner-new {
  height: 598px;
  // position: relative;

  @media (max-width: 992px) {
    height: auto;
    min-height: 500px;
  }

  @media (max-width: 768px) {
    min-height: 400px;
  }

  // 通用标题样式
  .swiper-title1 {
    font-size: 50px;
    font-weight: 800;
    color: #fff;
    line-height: 1.2;
    text-align: left;

    @media (max-width: 1200px) {
      font-size: 38px;
    }

    @media (max-width: 992px) {
      font-size: 32px;
      // text-align: center;
    }

    @media (max-width: 768px) {
      font-size: 24px;
    }

    @media (max-width: 480px) {
      font-size: 20px;
    }
  }

  .swiper-title2 {
    font-size: 22px;
    color: #fff;
    line-height: 1.4;
    text-align: left;

    @media (max-width: 1200px) {
      font-size: 18px;
    }

    @media (max-width: 992px) {
      font-size: 16px;
      // text-align: center;
    }

    @media (max-width: 768px) {
      font-size: 14px;
    }
  }

  .btn-zxzx {
    display: block;
    width: 180px;
    height: 58px;
    font-size: 19px;
    font-weight: 800;
    line-height: 58px;
    margin-top: 60px;
    cursor: pointer;
    transition: opacity 0.3s;
    color: white;
    border: 1px solid #fff !important;
    background: transparent !important;

    @media (max-width: 992px) {
      // margin: 30px auto 0;
    }

    @media (max-width: 768px) {
      width: 140px;
      height: 44px;
      font-size: 16px;
      line-height: 44px;
      margin-top: 20px;
    }

    &:hover {
      opacity: 0.9;
      background: rgba(255, 255, 255, 0.1) !important;
    }
  }

  // ===== 第一张 Banner: 企业用工风险解决专家 =====
  .contant-swiper2 {
    width: 100%;
    height: 598px;
    background: linear-gradient(180deg, #0A5FE8, #3794E0);
    position: relative;
    overflow: hidden;

    @media (max-width: 992px) {
      height: auto;
      min-height: 500px;
      flex-direction: column;
      padding: 20px 16px;
    }

    @media (max-width: 768px) {
      min-height: 400px;
      padding: 12px;
    }

    .left2 {
      padding-top: 72px;
      padding-bottom: 72px;
      position: absolute;
      top: 1%;
      left: 10%;
      z-index: 2;

      @media (max-width: 1200px) {
        left: 5%;
        padding-top: 40px;
        padding-bottom: 40px;
      }

      @media (max-width: 992px) {
        position: relative;
        top: auto;
        left: auto;
        padding: 30px 0 20px;
        text-align: center;
        width: 100%;
      }

      @media (max-width: 768px) {
        padding: 20px 0 10px;
      }
    }

    .right-box {
      width: 650px;
      height: 598px;
      padding-right: 150px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 3%;
      right: 15%;
      z-index: 1;

      @media (max-width: 1200px) {
        width: 500px;
        padding-right: 80px;
        right: 0;
      }

      @media (max-width: 992px) {
        position: relative;
        width: 100%;
        height: auto;
        padding: 20px 0;
        top: auto;
        right: auto;
      }
    }

    .right {
      height: 598px;
      margin-left: 30px;
      padding-right: 40px;
      width: 1000px;
      flex-shrink: 0;
      position: relative;

      @media (max-width: 1200px) {
        width: 100%;
        height: auto;
        margin-left: 0;
        padding-right: 0;
        min-height: 400px;
      }

      @media (max-width: 992px) {
        min-height: 300px;
      }

      .swiper-card-item {
        width: 150px;
        min-height: 80px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        background: rgba(36, 96, 202, 0.85);
        border-radius: 8px;
        padding: 10px;
        position: absolute;
        backdrop-filter: blur(4px);
        transition: transform 0.3s;

        @media (max-width: 1200px) {
          width: 130px;
          min-height: 70px;
          padding: 8px;
        }

        @media (max-width: 992px) {
          position: relative !important;
          width: 100%;
          min-height: auto;
          margin-bottom: 8px;
          top: auto !important;
          bottom: auto !important;
          left: auto !important;
          right: auto !important;
        }

        p {
          font-size: 14px;
          font-weight: 600;
          color: #fff;
          margin: 0 0 4px;

          @media (max-width: 768px) {
            font-size: 13px;
          }
        }

        span {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.9);
          text-align: left;

          @media (max-width: 768px) {
            font-size: 11px;
          }
        }

        &:hover {
          transform: scale(1.05);
        }
      }

      .dw1 {
        position: absolute;
        bottom: 180px;
        left: 130px;

        @media (max-width: 1200px) {
          bottom: 140px;
          left: 100px;
        }

        @media (max-width: 992px) {
          position: relative !important;
          bottom: auto !important;
          left: auto !important;
        }
      }

      .dw2 {
        position: absolute;
        bottom: 350px;
        left: 200px;

        @media (max-width: 1200px) {
          bottom: 280px;
          left: 160px;
        }

        @media (max-width: 992px) {
          position: relative !important;
          bottom: auto !important;
          left: auto !important;
        }
      }

      .dw3 {
        position: absolute;
        top: 50px;
        left: 380px;

        @media (max-width: 1200px) {
          top: 40px;
          left: 300px;
        }

        @media (max-width: 992px) {
          position: relative !important;
          top: auto !important;
          left: auto !important;
        }
      }

      .dw4 {
        position: absolute;
        top: 80px;
        right: 250px;

        @media (max-width: 1200px) {
          top: 60px;
          right: 200px;
        }

        @media (max-width: 992px) {
          position: relative !important;
          top: auto !important;
          right: auto !important;
        }
      }

      .dw5 {
        position: absolute;
        top: 200px;
        right: 200px;

        @media (max-width: 1200px) {
          top: 160px;
          right: 160px;
        }

        @media (max-width: 992px) {
          position: relative !important;
          top: auto !important;
          right: auto !important;
        }
      }

      .dw6 {
        position: absolute;
        bottom: 160px;
        right: 110px;
        width: 180px;

        @media (max-width: 1200px) {
          bottom: 120px;
          right: 80px;
          width: 160px;
        }

        @media (max-width: 992px) {
          position: relative !important;
          bottom: auto !important;
          right: auto !important;
          width: 100% !important;
        }
      }

      .image {
        width: 350px;
        max-width: 100%;
        height: auto;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        @media (max-width: 1200px) {
          width: 280px;
        }

        @media (max-width: 992px) {
          display: none;
        }
      }
    }
  }

  // ===== 第二张 Banner: 稳定且强大的服务系统 =====

  .banner-bg {
    position: relative;
    width: 100%;
    height: 598px;
    display: flex;
    align-items: center;

    @media (max-width: 992px) {
      height: auto;
      min-height: 500px;
      padding: 40px 20px;
      display: flex;
      align-items: center;
    }

    @media (max-width: 768px) {
      min-height: 400px;
      padding: 30px 16px;
      display: flex;
      align-items: center;
    }

    img {
      width: 100%;
      height: 598px;
      position: absolute;
      z-index: -1;
      top: 0;
      left: 0;

      @media (max-width: 992px) {
        max-height: 500px;
      }

      @media (max-width: 768px) {
        max-height: 400px;
      }
    }

    .banner-left {
      position: absolute;
      z-index: 1;
      padding-top: 72px;
      padding-bottom: 72px;
      padding-left: 0;
      left: 10%;

      @media (max-width: 1200px) {
        left: 5%;
        padding-top: 40px;
        padding-bottom: 40px;
      }

      @media (max-width: 992px) {
        left: 5%;
        padding: 30px 0 20px;
        // text-align: center;
        width: 100%;
      }

      @media (max-width: 768px) {
        left: 5%;
        padding: 20px 0 10px;
      }

      .swiper-title1,
      .swiper-title2 {
        text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
      }

      .btn-zxzx {
        @media (max-width: 992px) {
          // margin: 30px auto 0;
        }
      }
    }
  }



  .banner-bg-2 {
    // background: url("@/assets/images/banner3.png") no-repeat center center;
    // background: url("@/assets/images/banner1_new.png") no-repeat center center;
    // background-size: cover;
  }

  .banner-bg-1 {
    //   background: url("@/assets/images/banner2_new_1.jpg") no-repeat center center;
    // // background: url("@/assets/images/banner2_new3.png") no-repeat center center;
    // background-size: cover;
  }
}

// ===== 模块标题 =====
.mod-title {
  text-align: center;
  padding: 60px 0 40px;

  @media (max-width: 768px) {
    padding: 30px 16px 20px;
  }

  .title {
    font-size: 32px;
    font-weight: 600;
    color: #111;
    line-height: 1.4;
    letter-spacing: 1px;

    @media (max-width: 768px) {
      font-size: 24px;
    }

    @media (max-width: 480px) {
      font-size: 20px;
    }
  }

  .sed-title {
    font-size: 16px;
    color: #29375b;
    line-height: 1.4;
    padding-top: 14px;

    @media (max-width: 768px) {
      font-size: 14px;
      padding-top: 10px;
    }
  }
}

// ===== 产品卡片 =====
.back-tone {
  background: #fff;
  padding: 0 16px;

  .mod-title {
    margin-bottom: 32px;

    @media (max-width: 768px) {
      margin-bottom: 16px;
    }
  }

  .cards-row {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    // max-width: 1200px;
    margin: 0 auto;

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 12px;
    }
  }

  .card-col {
    flex: 1;
    min-width: 0;

    @media (max-width: 768px) {
      flex: none;
      width: 100%;
    }
  }

  .card-title {
    font-size: 18px;
    font-weight: 800;
    color: #29375b;
    line-height: 25px;
    border-top: 1px solid #eff2f6;
    padding: 27px 0;
    text-align: center;
    transition: border-color 0.3s;

    @media (max-width: 768px) {
      font-size: 16px;
      padding: 16px 0;
    }

    &.active {
      border-top: 2px solid #104aba;
    }
  }

  .card {
    width: 100%;
    height: 300px;
    background: #fff;
    box-shadow: 0 8px 28px 0 rgba(9, 37, 64, 0.06);
    border-radius: 8px;
    border: 1px solid #dbdfe7;
    font-size: 14px;
    color: #333;
    line-height: 22px;
    transition: all 0.3s;

    @media (max-width: 768px) {
      height: auto;
      min-height: 200px;
    }

    &:hover {
      box-shadow: 0 20px 30px 0 rgba(53, 59, 69, 0.2);
      border-radius: 10px;
    }

    .up {
      padding: 10px 16px;
      border-bottom: 1px dashed #e8e8e8;
      // background: linear-gradient(270deg, rgb(10 95 232 / 88%), #3794E0);

      .title {
        margin-bottom: 8px;
        font-size: 24px;
        font-weight: 700;
        // color: white;
        color:#111;
        line-height: 32px;

        @media (max-width: 768px) {
          font-size: 16px;
        }
      }

      .sub-title {
        // color: white;
        color:#111;
        font-size: 14px;

        @media (max-width: 768px) {
          font-size: 12px;
        }
      }
    }

    .down {
      padding: 16px 20px;

      @media (max-width: 768px) {
        padding: 12px 16px;
      }

      ul {
        margin: 0;
        padding: 0;
        list-style: none;

        li {
          float: left;
          margin-bottom: 22px;
          width: calc(50% - 12px);
          font-size: 16px;

          @media (max-width: 768px) {
            width: 100%;
            margin-bottom: 8px;
            font-size: 12px;
          }

          &:nth-child(odd) {
            margin-right: 24px;

            @media (max-width: 768px) {
              margin-right: 0;
            }
          }

          &::before {
            content: '';
            background: #d3d9e4;
            margin-right: 4px;
            display: inline-block;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            vertical-align: middle;
            flex-shrink: 0;
          }
        }
      }
    }

    &.custom {
      padding: 123px 0 0;
      background: linear-gradient(180deg, #104aba, #1d5edc);
      color: #fff;
      text-align: left;
      position: relative;
      border: none;
      height: 300px;

      @media (max-width: 768px) {
        padding: 40px 16px 20px;
        height: auto;
        min-height: 200px;
      }

      .title {
        margin: 0 24px 5px;
        font-size: 24px;
        font-weight: 600;
        line-height: 32px;
        color: #fff;

        @media (max-width: 768px) {
          font-size: 20px;
          margin: 0 0 8px;
        }
      }

      .detail {
        margin: 0 24px 18px;
        font-size: 16px;
        color: #fff;
        line-height: 22px;

        @media (max-width: 768px) {
          margin: 0 0 16px;
          font-size: 14px;
        }
      }

      img {
        width: 158px;
        bottom: -10%;
        right: 5%;
        position: absolute;

        @media (max-width: 768px) {
          display: none;
        }
      }

      .btn {
        border: none;
        border-radius: 24px;
        height: 44px;
        width: 144px;
        font-size: 16px;
        font-weight: 600;
        color: #0053fa;
        line-height: 44px;
        background: #fff;
        margin: 0 24px 18px;
        cursor: pointer;

        @media (max-width: 768px) {
          margin: 0 0 0;
          width: 120px;
          height: 40px;
          font-size: 14px;
          line-height: 40px;
        }

        &:hover {
          color: #3883fd;
        }
      }
    }
  }
}

// ===== 流程步骤 =====
.plant-wide {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 16px;

  .step-box {
    width: 100%;
    // max-width: 1200px;
    // height: auto;
    // aspect-ratio: 1200 / 657;
    // position: relative;
    padding: 50px 200px 50px 200px;

    @media (max-width: 768px) {
      aspect-ratio: 1 / 1;
    }

    .step-image {
      width: 70%;
      height: auto;
      // object-fit: contain;
      // position: absolute;
      // top: 50%;
      // left: 50%;
      // transform: translate(-50%, -50%);
    }
  }
}

// ===== 背调优势 =====
.back-advantage {
  margin-bottom: 40px;
  padding: 0 16px;
  overflow: visible !important;

  @media (max-width: 768px) {
    margin-bottom: 20px;
    padding: 0 12px;
  }

  .advantages-box {
    // max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    padding: 0 200px;
    gap: 24px;
    overflow: visible !important;
    width: 100%;

    @media (max-width: 992px) {
      gap: 16px;
    }

    @media (max-width: 768px) {
      gap: 16px;
    }
  }

  .item {
    flex: 0 0 calc((100% - 48px) / 3);
    max-width: calc((100% - 48px) / 3);
    min-height: 321px;
    height: auto;
    // height: 330px;
    border-radius: 8px;
    border: 1px solid #d3d9e4;
    padding: 25px;
    box-shadow: 0 8px 28px 0 rgba(9, 37, 64, 0.06);
    transition: all 0.3s;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    overflow: visible !important;
    box-sizing: border-box;

    @media (max-width: 992px) {
      flex: 0 0 calc((100% - 16px) / 2);
      max-width: calc((100% - 16px) / 2);
      min-height: 280px;
      padding: 20px;
    }

    @media (max-width: 768px) {
      flex: 0 0 100%;
      max-width: 100%;
      min-height: auto;
      padding: 20px;
    }

    @media (max-width: 480px) {
      padding: 16px;
    }

    &:hover {
      box-shadow: 0 20px 30px 0 rgba(53, 59, 69, 0.2);
      border-radius: 10px;
    }

    .icon {
      width: 96px;
      height: 96px;
      margin: 0 auto 16px;
      flex-shrink: 0;

      @media (max-width: 768px) {
        width: 80px;
        height: 80px;
        margin: 0 auto 12px;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .title {
      font-size: 20px;
      font-weight: 800;
      color: #29375b;
      line-height: 1.4;
      margin-bottom: 14px;
      word-break: break-word;
      width: 100%;

      @media (max-width: 768px) {
        font-size: 18px;
        margin-bottom: 12px;
        text-align: center;
      }
    }

    .detail {
      font-size: 16px;
      color: #29375b;
      line-height: 1.8;
      text-align: left;
      flex: 1;
      word-break: break-word;
      overflow-wrap: break-word;
      max-width: 100%;
      width: 100%;

      @media (max-width: 768px) {
        font-size: 15px;
        line-height: 1.8;
      }

      @media (max-width: 480px) {
        font-size: 14px;
        line-height: 1.6;
      }
    }
  }
}

// ===== 响应式补充 =====
@media (max-width: 480px) {
  .home {
    padding-top: 56px;
  }

  .mod-title {
    padding: 20px 12px 16px;

    .title {
      font-size: 18px;
    }

    .sed-title {
      font-size: 13px;
    }
  }

  .banner-new {
    .swiper-title1 {
      font-size: 18px;
    }

    .swiper-title2 {
      font-size: 13px;
    }

    .btn-zxzx {
      width: 120px;
      height: 38px;
      font-size: 14px;
      line-height: 38px;
      margin-top: 16px;
    }
  }

  .back-advantage .item {
    .title {
      font-size: 16px;
    }

    .detail {
      font-size: 13px;
    }
  }
}
</style>